import { z } from "zod/v4-mini";
/**
 * Serializable structure that represents an option.
 */
export const Option = z.object({
    type: z.literal("option"),
    disabled: z.optional(z.boolean()),
    label: z.string(),
    value: z.union([z.boolean(), z.number(), z.string()]),
});
/**
 * Creates a new option.
 * @param props Properties that define the option.
 * @returns The option.
 */
export function option(props) {
    const { disabled, label, value } = props;
    return {
        type: "option",
        disabled,
        label,
        value,
    };
}
